<template>
  <div
    class="e4Widget"
  >
    <div class="e4Widget__filter">
      <v-btn
        small
        class="addBtn m-2"
        @click="filterDatesForm"
      >
        <v-icon class="ml-1">
          {{ filterDatesOpen ? 'mdi-chevron-up' : 'mdi-chevron-down' }}
        </v-icon>
        {{ $t('dashboard.e4.editPeriod') }}
      </v-btn>
    </div>
    <FilterDatesForm
      v-if="filterDatesOpen"
      @onChange="editPeriod"
    />


    <div
      class="e4Widget__title"
    >
      {{ $t('dashboard.e4.totalSavings') }}
    </div>
    <div
      class="e4Widget__subtitle"
    >
      {{ period.rangeOfPeriod.start && period.rangeOfPeriod.end &&
        `${$t('dashboard.e4.workOrdersFrom')}
        ${moment(period.rangeOfPeriod.start).add(1, 'day').format('YYYY/MM/DD')}
        ${$t('dashboard.e4.to')}
        ${moment(period.rangeOfPeriod.end).add(1, 'day').format('YYYY/MM/DD')}`
      }}
    </div>
    <div
      class="e4Widget__circle"
    >
      <div
        style="width:125px; display: flex; justify-content: center;"
      >
        <v-img
          src="@/assets/images/widgets/e4/circleColored.svg"
        />
      </div>
    </div>
    <div
      v-if="w > 4"
      class="e4Widget__thumbnail"
    >
      <Thunbnail
        v-for="energy in energySaved"
        :key="energy.name"
        :energy="energy"
        :w="w"
      />
    </div>
    <div
      v-else
      class="e4Widget__thumbnail"
    >
      <Thunbnail
        :energy="energySaved.find(item => item.name === itemEconomyDisplayed)"
        :w="w"
      />
    </div>


    <div
      v-if="w <= 4"
      class="e4Widget__pagination"
    >
      <div
        v-for="i in energySaved"
        :key="i"
        style="display: flex; justify-content: center;"
        class="e4Widget__pagination__item"
      >
        <v-img
          :src="require(`@/assets/images/widgets/e4/pagination-${i.name}${i.name === itemEconomyDisplayed ? 'Activated' : ''}.svg`)"
          style="cursor: pointer;"
          @click="itemEconomyDisplayed = i.name"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

// eslint-disable-next-line no-unused-vars
import moment from 'moment';
import Thunbnail from './Thunbnail.vue';
import FilterDatesForm from './FilterDatesForm.vue';

export default {
    name: 'E4',
    components: {
        Thunbnail,
        FilterDatesForm,
    },

    props: {
        w: {
            type: Number,
            required: true,
        },
        h: {
            type: Number,
            required: true,
        },
    },
    data() {
        return {
            energySaved: [
                {
                    name: 'waterSavings',
                    valueSaved: 0, // ça vient en litre du backend
                },
                {
                    name: 'CO2',
                    valueSaved: 0, // ça vient en Kgs du backend
                },
                {
                    name: 'energySavings',
                    valueSaved: 0, // ça vient en KwH du backend
                },
            ],
            period: {
                rangeOfPeriod: {
                    startDate: null,
                    endDate: null,
                },
                typeOfPeriod: 'all',
            },

            itemEconomyDisplayed: 'waterSavings', // Utilisé pour la pagination quand le widget est petit
            economies: null,
            filterDatesOpen: false,
        };
    },
    computed: {
        ...mapGetters([
            'site',
        ]),
    },

    created() {
        this.getEconomies();
    },
    methods: {
        async getEconomies(startDate, endDate) {
            const startDatePayload = startDate || null;
            const endDatePayload = endDate || null;
            const { data } = await this.$rq.getEconomies(this.site.id, startDatePayload, endDatePayload);

            this.energySaved.find(item => item.name === 'waterSavings').valueSaved = data.totalWaterSavings;
            this.energySaved.find(item => item.name === 'CO2').valueSaved = data.totalCO2EmissionsAvoided;
            this.energySaved.find(item => item.name === 'energySavings').valueSaved = data.totalEnergySavings;
        },
        filterDatesForm() {
            this.filterDatesOpen = !this.filterDatesOpen;
        },
        editPeriod(p) {
            this.period = p;

            if (p.typeOfPeriod === 'all') {
                this.getEconomies();
            }
            if (p.typeOfPeriod === 'specific' && p.rangeOfPeriod.start !== '' && p.rangeOfPeriod.end !== '') {
                const startDate = new Date(`${p.rangeOfPeriod.start }T00:00:00Z`);
                const endDate = new Date(`${p.rangeOfPeriod.end }T23:59:59Z`);
                this.getEconomies(startDate.toISOString(), endDate.toISOString());
            }
            if (p.typeOfPeriod === 'year' && p.rangeOfPeriod.start !== '' && p.rangeOfPeriod.end !== '') {
                this.getEconomies(p.rangeOfPeriod.start, p.rangeOfPeriod.end);
            }
        },
    },
};
</script>

<style lang="scss">
    .e4Widget {
        &__filter {
            width: 150px;
        }
        &__title {
            width: 100%;
            font-size: 2rem;
            text-align: center;
            font-weight: 600;
        }
        &__subtitle {
            width: 100%;
            font-weight: 400;
            margin-bottom: 20px;
            text-align: center;
            margin-top: -5px
        }
        &__circle {
            width: 100%;
            display: flex;
            justify-content: center;
            .v-image  {
                width: 100px !important;
            }
            margin-bottom: 20px;
        }
        &__thumbnail {
            width: 100%;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
            &__container {
                border: 1px solid #9e9e9e;
                border-radius: 10px;
                height: 350px;
                padding: 10px;
                width: 100%;
                &__title {
                  display: flex;
                  flex-direction: row;
                  align-items: center;
                  margin-bottom: 10px;
                  height: 10%;
                }
                &__paragraph {
                  height: 20%;

                  &__valueSaved {
                    margin-top: 10px;
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    margin-bottom: 10px;
                  }
                }
                &__economies{
                  display: flex;
                  flex-direction: column;
                  justify-content: center;
                  align-items: center;
                  padding: 10px;
                  background-color: rgb(230, 230, 230);
                  height: calc(50% - 10px);
                  border-radius: 0px 0px 10px 10px;
                  margin-left : -10px;
                  margin-right : -10px;
                  &__text {
                    font-weight: 400;
                    font-size: 1.3rem;
                    text-align: center;
                  }

                }
            }
        }
        &__pagination {
            display: flex;
            flex-direction: row;
            justify-content: center;
            margin-top: 10px;
            gap: 10px;
            &__item {
                width: 10%;
            }
        }
    }

</style>
